import {createAction} from 'redux-actions';
import {curry} from 'ramda';
import tryToCatch from 'try-to-catch';
import {setNotificationAction as setNotification} from '@pluto/notification/Redux/NotificationActions';
import {createNewIngestItem} from '@pluto/rest';

export const CREATE_NEW_INGEST_ITEM = 'CREATE_NEW_INGEST_ITEM';

export const newIngestItemAction = createAction(CREATE_NEW_INGEST_ITEM);

export const createNewIngestItemAction = curry(async (newIngestBody, dispatch) => {
    const [error] = await tryToCatch(createNewIngestItem, newIngestBody);
    
    if (!error) {
        return dispatch(setNotification({
            type: 'success',
            text: 'New ingest config added',
        }));
    }
    
    const {data: errorData} = error.response;
    
    dispatch(setNotification({
        type: 'error',
        text: errorData.message,
    }));
});
